<sm-title-bar pageTitle="{{ 'employee_salary_settings.title' | translate }}" [back]="true"  [headerCustomTemplate]="addButton">
    <ng-template #addButton>
        <div class="d-flex search-field salasy_seeting_btn" (click)="addSalarySetting()" *ngIf="salaryData.length == 0">
          <button class="" mat-flat-button>
            <mat-icon class="material-icons-round" [inline]="true"
            >add</mat-icon>
            {{ 'employee_salary_settings.btn_text' | translate }}
          </button>
        </div>
      </ng-template> 
  </sm-title-bar>

  <!-- <div class="merchant_detail_sec" *ngIf="!loader">
    <div class="mrt_offe">
      <div class="row">
        <div class="col-sm-12">
          <div class="drt_head">
          </div>
          <div class="list_user">
          <a href="javascript:void(0)" class="admin_category">
              <div class="card_header chead">
                <div class="adm_set">
                  <div>
                    <span class="name_cont">{{ 'employee_salary_settings.settings_info' | translate }}</span>
                    <button *ngIf="salaryData.length > 0"
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      class="profile_button"
                      class="share">
                      <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="editSalary(salaryData[0])">
                        <mat-icon class="material-icons-outlined">edit</mat-icon>
                        <span class="menu_text">{{ 'employee_salary_settings.opt_edit' | translate }}</span>
                      </button>
                    </mat-menu>
                  </div>
  
                </div>
  
              </div>
              <div class="card_body cbody">
                
                <div class="row" *ngIf="salaryData.length > 0">
                  
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> segment </span>
                        </div>
  
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.pay_type' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                          {{salaryData[0].payType1 | titlecase}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.pay_rate' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].payRate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.paid_on' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].paidOn1 | titlecase}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.net_payment' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].netPayment}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.other_perks' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].otherPerks}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.perks_type' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].perksType | titlecase}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.deduction' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].deduction}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat">
                            segment
                          </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                          {{ 'employee_salary_settings.deduction_type' | translate }}
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail">
                         
                         {{salaryData[0].deductionType | titlecase}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="salaryData.length == 0" style="text-align: center;">
                  <div class="col-md-12">
                    <p style="color:#6d6d6d;">{{ 'employee_salary_settings.no_placeholder' | translate }}</p>
                   
                    
                      <button mat-flat-button color="accent" (click)="addSalarySetting()" style="    margin-top: 18px;">
                        {{ 'employee_salary_settings.btn_text' | translate }}
                        <mat-icon class="material-icons-round" [inline]="true" style="font-size: 20px !important;"
                          >add</mat-icon
                        >
                      </button>
              
                
                   
                  </div>
                </div>
              </div>
  
              
            </a>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  

  
  <!-- <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="editSalary(rowvalue)">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span>Edit</span>
    </button>
  </ng-template> -->
    <!-- <button mat-menu-item *ngIf="rowvalue.status == 1 && rowvalue.toShowType =='parent'" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">link</mat-icon>
      <span>Add more</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="removeTime(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Remove</span>
    </button> -->

  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->
       <!-- owner info -->
       <div class="service_info" *ngIf="salaryData.length > 0 && !loader">
        <div class="row">
            <div class="col-sm-12">
                <div class="serv_seingo">
                  <div class="adm_set">
                    <div>
                      <button *ngIf="salaryData.length > 0 && !loader"
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        class="profile_button"
                        class="share">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editSalary(salaryData[0])">
                          <mat-icon class="material-icons-outlined">edit</mat-icon>
                          <span class="menu_text">{{ 'employee_salary_settings.opt_edit' | translate }}</span>
                        </button>
                      </mat-menu>
                    </div>
    
                  </div>
                    <h3>{{ 'employee_salary_settings.settings_info' | translate }}</h3>
                </div>
              
            </div>
            <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Pay Type </h4>
                    <p>  {{salaryData[0].payType1 | titlecase}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Pay Rate </h4>
                    <p> {{salaryData[0].currency_symbol}}{{salaryData[0].payRate.toFixed(2)}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>analytics</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4>  Paid On </h4>
                    <p> {{salaryData[0].paidOn1 | titlecase}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh" style="border-right: none !important;">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Gross payment </h4>
                    <p> {{salaryData[0].currency_symbol}}{{salaryData[0].netPayment.toFixed(2)}} </p>
                </div>
            </div>
        </div>
        <hr class="saley_csv">
        <div class="col-sm-3">
          <div class="service_listh">
              <div class="bus_icon">
                  <mat-icon>receipt_long</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4> Other Perks  </h4>
                  <p>  {{salaryData[0].currency_symbol}}{{salaryData[0].otherPerks.toFixed(2)}}  </p>
              </div>
          </div>
      </div>
      <div class="col-sm-3">
        <div class="service_listh" >
            <div class="bus_icon">
                <mat-icon>article</mat-icon>
            </div>
            <div class="bus_hjk">
                <h4> Perks Type </h4>
                <p>  {{salaryData[0].perksType | titlecase}}  </p>
            </div>
        </div>
    </div>
    <div class="col-sm-3">
      <div class="service_listh">
          <div class="bus_icon">
              <mat-icon>subtitles</mat-icon>
          </div>
          <div class="bus_hjk">
              <h4>  Deduction  </h4>
              <p>  {{salaryData[0].currency_symbol}}{{salaryData[0].deduction.toFixed(2)}}  </p>
          </div>
      </div>
  </div>
  <div class="col-sm-3">
    <div class="service_listh" style="border-right: none !important;">
        <div class="bus_icon">
            <mat-icon>subtitles</mat-icon>
        </div>
        <div class="bus_hjk">
            <h4>   Deduction Type   </h4>
            <p>  {{salaryData[0].deductionType && salaryData[0].deductionType != 'null' ? (salaryData[0].deductionType | titlecase) : 'N/A'}}  </p>
        </div>
    </div>
</div>
        </div>
       </div>


       <!-- placeholder section start -->
       <div class="row" *ngIf="salaryData.length == 0 && !loader">
        <div class="col-sm-12" >
          <div style="padding: 20px 18px 20px 18px;
          border-radius: var(--dra-radius-x-small);transition: 0.3s;">
            <div class="top_section_order">
              <div class="row">
               <div class="nal_rrty">
                <div style="text-align:center;min-height: 500px;padding-top: 210px">
                <div class="cv_notifia">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M490.667 405.333h-56.811C424.619 374.592 396.373 352 362.667 352s-61.931 22.592-71.189 53.333H21.333C9.557 405.333 0 414.891 0 426.667S9.557 448 21.333 448h270.144c9.237 30.741 37.483 53.333 71.189 53.333s61.931-22.592 71.189-53.333h56.811c11.797 0 21.333-9.557 21.333-21.333s-9.535-21.334-21.332-21.334zm-128 53.334c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.358 32-32 32zM490.667 64h-56.811c-9.259-30.741-37.483-53.333-71.189-53.333S300.736 33.259 291.477 64H21.333C9.557 64 0 73.557 0 85.333s9.557 21.333 21.333 21.333h270.144C300.736 137.408 328.96 160 362.667 160s61.931-22.592 71.189-53.333h56.811c11.797 0 21.333-9.557 21.333-21.333S502.464 64 490.667 64zm-128 53.333c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.358 32-32 32zM490.667 234.667H220.523c-9.259-30.741-37.483-53.333-71.189-53.333s-61.931 22.592-71.189 53.333H21.333C9.557 234.667 0 244.224 0 256c0 11.776 9.557 21.333 21.333 21.333h56.811c9.259 30.741 37.483 53.333 71.189 53.333s61.931-22.592 71.189-53.333h270.144c11.797 0 21.333-9.557 21.333-21.333.001-11.776-9.535-21.333-21.332-21.333zM149.333 288c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.357 32-32 32z" fill="#a0a0a0" opacity="1" data-original="#000000" class=""></path></g></svg>                  
                </div>
                <div>
                  <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">Employee Salary Settings: Configure base salary, allowances, deductions,  <br> and payment cycle. Manage tax, 
                    benefits, and overtime policies efficiently.
                 </p>
               </div>
                </div>
              </div>
             </div>
            </div>
          </div>
        </div>
      </div>
<!-- placeholder section end -->

<!-- end -->